<button
    class="picker-button"
    nz-button
    nzType="default"
    nz-dropdown
    nzTrigger="click"
    [nzDropdownMenu]="menu"
    type="button"
    [nzClickHide]="false"
    (nzVisibleChange)="onDropdownChange($event)"
    [(nzVisible)]="isCalendarOpen"
>
    <div class="button-wrapper a-fx a-fx-col a-fx-around-start">
        <svg class="adspt-icon icon-calendar h3">
            <use xlink:href="#adspt-calendar"></use>
        </svg>

        <p class="date">{{ dates$ | async }}</p>

        <p class="compare" *ngIf="hasCompareRange">
            {{ 'global-filter.date-selector.compare' | translate }} {{ displayCompareDate }}
        </p>
    </div>
</button>

<nz-dropdown-menu #menu="nzDropdownMenu">
    <ng-container *ngIf="isCalendarOpen">
        <div class="daterange-wrapper a-fx a-fx-col" *ngIf="ranges$ | async">
            <div class="a-fx-around-start a-fx" style="position: relative">
                <div class="date-calendar left">
                    <div class="calendar-table">
                        <table class="table-condensed">
                            <thead>
                                <tr>
                                    <th *ngIf="showWeekNumbers"></th>

                                    <th
                                        (click)="clickPrev(sideEnum.left); updateCalendars()"
                                        class="prev available"
                                        *ngIf="
                                            !drs.calendarState.left.minDate || drs.isBeforeMinDate(true);
                                            else tmplArrow
                                        "
                                    >
                                        <adspt-icon name="caret-down" />
                                    </th>

                                    <th colspan="5" class="month">
                                        <ng-container *ngIf="!drs.calendarState.left.dropdowns; else tmplLeftDropDowns">
                                            {{ drs.showSelectedMonth(true) }} {{ drs.showSelectedYear(true) }}
                                        </ng-container>

                                        <ng-template #tmplLeftDropDowns>
                                            <div class="dropdowns">
                                                {{ drs.showSelectedMonth(true) }}
                                                <select
                                                    class="monthselect"
                                                    (change)="monthChanged($event, sideEnum.left)"
                                                >
                                                    <option
                                                        [disabled]="
                                                            (drs.calendarState.left.dropdowns.inMinYear &&
                                                                m < drs.getMinDateMonth(true)) ||
                                                            (drs.calendarState.left.dropdowns.inMaxYear &&
                                                                m > drs.getMaxDateMonth(true))
                                                        "
                                                        *ngFor="let m of drs.calendarState.left.dropdowns.monthArrays"
                                                        [value]="m"
                                                        [selected]="drs.calendarState.left.dropdowns.currentMonth === m"
                                                    >
                                                        {{ locale.monthNames[m] }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="dropdowns">
                                                {{ drs.showSelectedYear(true) }}
                                                <select
                                                    class="yearselect"
                                                    (change)="yearChanged($event, sideEnum.left)"
                                                >
                                                    <option
                                                        *ngFor="let y of drs.calendarState.left.dropdowns.yearArrays"
                                                        [selected]="y === drs.calendarState.left.dropdowns.currentYear"
                                                    >
                                                        {{ y }}
                                                    </option>
                                                </select>
                                            </div>
                                        </ng-template>
                                    </th>

                                    <th
                                        class="next available"
                                        (click)="clickNext(sideEnum.left); updateCalendars()"
                                        [ngClass]="{ disabled: disableArrows(sideEnum.left, sideEnum.right) }"
                                        *ngIf="
                                            (!drs.calendarState.left.maxDate ||
                                                isAfter(
                                                    drs.calendarState.left.maxDate,
                                                    drs.calendarState.left.calendar.lastDay
                                                )) &&
                                                !linkedCalendars;
                                            else tmplArrow
                                        "
                                    >
                                        <adspt-icon name="caret-down" />
                                    </th>
                                </tr>

                                <tr class="week-days">
                                    <th *ngIf="showWeekNumbers" class="week">
                                        <span>W</span>
                                    </th>

                                    <th *ngFor="let dayofweek of locale.daysOfWeek">
                                        <span>{{ dayofweek }}</span>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    *ngFor="let row of drs.calendarState.left.calRows"
                                    [class]="drs.calendarState.left.classes[row]?.classList"
                                >
                                    <td class="week" *ngIf="showWeekNumbers">
                                        <span>{{ drs.getDisplayWeek(row, true) }}</span>
                                    </td>

                                    <td
                                        *ngFor="let col of drs.calendarState.left.calCols"
                                        [class]="drs.calendarState.left.classes[row][col]"
                                        (click)="clickDate(sideEnum.left, row, col); $event.stopPropagation()"
                                        (mouseenter)="hoverDate(sideEnum.left, row, col)"
                                    >
                                        <span
                                            nz-tooltip
                                            nzTooltipPlacement="top"
                                            [nzTooltipMouseLeaveDelay]="0"
                                            [nzTooltipTitle]="tooltipTemplate"
                                            nzTooltipOverlayClassName="date-range-tooltip"
                                            [nzTooltipColor]="selectedInput < 2 ? '#009ee0' : '#005a8c'"
                                        >
                                            {{ drs.getDisplayDay(row, col, true) }}
                                        </span>

                                        <ng-template #tooltipTemplate>
                                            <div *ngIf="drs.getDisplayDate(row, col, true) as selecteDate">
                                                <div
                                                    *ngIf="
                                                        selectedInput === 0 ||
                                                        (selectedInput === 1 && selecteDate < +dates[0])
                                                    "
                                                >
                                                    {{ 'global-filter.date-selector.hover-types.start' | translate }}
                                                </div>

                                                <div *ngIf="selectedInput === 1 && selecteDate >= +dates[0]">
                                                    {{ 'global-filter.date-selector.hover-types.end' | translate }}
                                                </div>

                                                <div
                                                    *ngIf="
                                                        selectedInput === 2 ||
                                                        (selectedInput === 3 && selecteDate < +compareDates[0])
                                                    "
                                                >
                                                    {{
                                                        'global-filter.date-selector.hover-types.compare-start'
                                                            | translate
                                                    }}
                                                </div>

                                                <div *ngIf="selectedInput === 3 && selecteDate >= +compareDates[0]">
                                                    {{
                                                        'global-filter.date-selector.hover-types.compare-end'
                                                            | translate
                                                    }}
                                                </div>
                                            </div>
                                        </ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="date-calendar right">
                    <div class="calendar-table">
                        <table class="table-condensed" *ngIf="drs.calendarState">
                            <thead>
                                <tr>
                                    <th *ngIf="showWeekNumbers"></th>

                                    <th
                                        (click)="clickPrev(sideEnum.right); updateCalendars()"
                                        class="prev available"
                                        [ngClass]="{ disabled: disableArrows(sideEnum.right, sideEnum.left) }"
                                        *ngIf="
                                            (!drs.calendarState.right.minDate || drs.isBeforeMinDate(false)) &&
                                                !linkedCalendars;
                                            else tmplArrow
                                        "
                                    >
                                        <adspt-icon name="caret-down" />
                                    </th>

                                    <th colspan="5" class="month">
                                        <ng-container
                                            *ngIf="!drs.calendarState.right.dropdowns; else tmplRightDropDowns"
                                        >
                                            {{ drs.showSelectedMonth(false) }} {{ drs.showSelectedYear(false) }}
                                        </ng-container>

                                        <ng-template #tmplRightDropDowns>
                                            <div class="dropdowns">
                                                {{ drs.showSelectedMonth(false) }}
                                                <select
                                                    class="monthselect"
                                                    (change)="monthChanged($event, sideEnum.right)"
                                                >
                                                    <option
                                                        [disabled]="
                                                            (drs.calendarState.right.dropdowns.inMinYear &&
                                                                drs.calendarState.right.minDate &&
                                                                m < drs.getMinDateMonth(false)) ||
                                                            (drs.calendarState.right.dropdowns.inMaxYear &&
                                                                drs.calendarState.right.maxDate &&
                                                                m > drs.getMaxDateMonth(false))
                                                        "
                                                        *ngFor="let m of drs.calendarState.right.dropdowns.monthArrays"
                                                        [value]="m"
                                                        [selected]="
                                                            drs.calendarState.right.dropdowns.currentMonth === m
                                                        "
                                                    >
                                                        {{ locale.monthNames[m] }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div class="dropdowns">
                                                {{ drs.showSelectedYear(false) }}
                                                <select
                                                    class="yearselect"
                                                    (change)="yearChanged($event, sideEnum.right)"
                                                >
                                                    <option
                                                        *ngFor="let y of drs.calendarState.right.dropdowns.yearArrays"
                                                        [selected]="y === drs.calendarState.right.dropdowns.currentYear"
                                                    >
                                                        {{ y }}
                                                    </option>
                                                </select>
                                            </div>
                                        </ng-template>
                                    </th>

                                    <th
                                        class="next available"
                                        (click)="clickNext(sideEnum.right); updateCalendars()"
                                        *ngIf="
                                            !drs.calendarState.right.maxDate ||
                                                isAfter(
                                                    drs.calendarState.right.maxDate,
                                                    drs.calendarState.right.calendar.lastDay
                                                );
                                            else tmplArrow
                                        "
                                    >
                                        <adspt-icon name="caret-down" />
                                    </th>
                                </tr>

                                <tr class="week-days">
                                    <th *ngIf="showWeekNumbers" class="week">
                                        <span>{{ this.locale.weekLabel }}</span>
                                    </th>

                                    <th *ngFor="let dayofweek of locale.daysOfWeek">
                                        <span>{{ dayofweek }}</span>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr
                                    *ngFor="let row of drs.calendarState.right.calRows"
                                    [class]="drs.calendarState.right.classes[row]?.classList"
                                >
                                    <td class="week" *ngIf="showWeekNumbers">
                                        <span>{{ drs.getDisplayWeek(row, false) }}</span>
                                    </td>

                                    <td
                                        *ngFor="let col of drs.calendarState.right.calCols"
                                        [class]="drs.calendarState.right.classes[row][col]"
                                        (click)="clickDate(sideEnum.right, row, col); $event.stopPropagation()"
                                        (mouseenter)="hoverDate(sideEnum.right, row, col)"
                                    >
                                        <span
                                            nz-tooltip
                                            nzTooltipPlacement="top"
                                            [nzTooltipMouseLeaveDelay]="0"
                                            [nzTooltipTitle]="tooltipTemplate"
                                            nzTooltipOverlayClassName="date-range-tooltip"
                                            [nzTooltipColor]="selectedInput < 2 ? '#009ee0' : '#005a8c'"
                                        >
                                            {{ drs.getDisplayDay(row, col, false) }}
                                        </span>

                                        <ng-template #tooltipTemplate>
                                            <div *ngIf="drs.getDisplayDate(row, col, false) as selecteDate">
                                                <div
                                                    *ngIf="
                                                        selectedInput === 0 ||
                                                        (selectedInput === 1 && selecteDate < +dates[0])
                                                    "
                                                >
                                                    {{ 'global-filter.date-selector.hover-types.start' | translate }}
                                                </div>

                                                <div *ngIf="selectedInput === 1 && selecteDate >= +dates[0]">
                                                    {{ 'global-filter.date-selector.hover-types.end' | translate }}
                                                </div>

                                                <div
                                                    *ngIf="
                                                        selectedInput === 2 ||
                                                        (selectedInput === 3 && selecteDate < +compareDates[0])
                                                    "
                                                >
                                                    {{
                                                        'global-filter.date-selector.hover-types.compare-start'
                                                            | translate
                                                    }}
                                                </div>

                                                <div *ngIf="selectedInput === 3 && selecteDate >= +compareDates[0]">
                                                    {{
                                                        'global-filter.date-selector.hover-types.compare-end'
                                                            | translate
                                                    }}
                                                </div>
                                            </div>
                                        </ng-template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="actions">
                    <p
                        class="ranges a-fx-start-start a-fx"
                        *ngFor="let range of ranges"
                        [ngClass]="{ active: range.active }"
                        [disabled]="disableRange(range.type)"
                        (click)="clickRange(range.type)"
                    >
                        {{ translations.ranges[range.type] }}
                    </p>

                    <nz-divider></nz-divider>

                    <p class="label a-fx-between-center a-fx">{{ translations['date-range'] }}</p>

                    <div class="range-inputs a-fx-between-start a-fx">
                        <adspt-date-range-input
                            tabindex="1"
                            [selected]="selectedInput === 0"
                            [date]="dates[0]"
                            [maxDate]="tomorrow"
                            (dateChange)="onStartDateChange($event)"
                            (click)="onStartDateClick()"
                        ></adspt-date-range-input>

                        <nz-divider></nz-divider>

                        <adspt-date-range-input
                            tabindex="2"
                            [selected]="selectedInput === 1"
                            [date]="dates[1]"
                            [minDate]="dates[0]"
                            [maxDate]="tomorrow"
                            [class.disabled]="!dates[0]"
                            (dateChange)="onEndDateChange($event)"
                            (click)="onEndDateClick()"
                        ></adspt-date-range-input>
                    </div>

                    <div
                        *ngIf="hasCompareRange"
                        class="compare-section a-fx a-fx-col-reverse"
                        [class.disabled]="!dates[0] || !dates[1]"
                        nz-tooltip
                        [nzTooltipTitle]="
                            !dates[0] || !dates[1]
                                ? 'Compare section is enabled only when start & end dates are selected'
                                : null
                        "
                    >
                        <div class="range-inputs a-fx-between-start a-fx">
                            <adspt-date-range-input
                                tabindex="3"
                                class="secondary"
                                [selected]="selectedInput === 2"
                                [date]="compareDates[0]"
                                [maxDate]="oneDayBeforeStartDate"
                                (dateChange)="onCompareStartDateChange($event)"
                                (click)="onCompareStartDateClick()"
                                tooltipPlacement="bottom"
                            ></adspt-date-range-input>

                            <nz-divider></nz-divider>

                            <adspt-date-range-input
                                tabindex="4"
                                class="secondary"
                                [selected]="selectedInput === 3"
                                [date]="compareDates[1]"
                                [minDate]="compareDates[0]"
                                [maxDate]="oneDayBeforeStartDate"
                                [class.disabled]="!compareDates[0]"
                                (dateChange)="onCompareEndDateChange($event)"
                                (click)="onCompareEndDateClick()"
                                tooltipPlacement="bottom"
                            ></adspt-date-range-input>
                        </div>

                        <div class="aa-fx a-fx-col a-fx-between-start">
                            <p class="label a-fx-between-center a-fx a-text-bold">{{ translations['compare-txt'] }}</p>
                            <nz-select
                                tabindex="-1"
                                class="label"
                                [ngModel]="selectedCompareType"
                                (ngModelChange)="onCustomRangeChange($event)"
                                nzSize="small"
                                nzBorderless
                                [nzDropdownMatchSelectWidth]="false"
                            >
                                <nz-option
                                    *ngFor="let item of compareTypes"
                                    class="label"
                                    [nzValue]="item"
                                    [nzLabel]="translations.ranges[item]"
                                ></nz-option>
                            </nz-select>
                        </div>
                    </div>
                </div>

                <div class="legend">
                    <p class="caption-2">
                        <span></span>
                        {{ 'global-filter.date-selector.date-range' | translate }}
                    </p>

                    <p class="caption-2" *ngIf="hasCompareRange">
                        <span class="compare"></span>
                        {{ 'global-filter.date-selector.compare-range' | translate }}
                    </p>
                </div>
            </div>

            <div class="a-fx-around-center a-fx">
                <p class="show-note label">
                    {{ (showNote$ | async) ? ('common.amz-data-partial-caption' | translate) : '' }}
                </p>

                <div class="actions btn">
                    <button
                        nz-button
                        nzType="default"
                        type="button"
                        (click)="isCalendarOpen = false; onCancel()"
                        style="margin-right: 8px"
                    >
                        {{ 'common.cancel' | translate }}
                    </button>

                    <button
                        nz-button
                        nzType="primary"
                        type="button"
                        (click)="onApply()"
                        adsptHeap="date-range-global-selector"
                        [heapData]="getHeapData()"
                    >
                        {{ 'global-filter.apply' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</nz-dropdown-menu>

<ng-template #tmplArrow>
    <th></th>
</ng-template>

<adspt-toaster
    *ngIf="toast"
    type="error"
    [duration]="3000"
    [title]="'global-filter.date-selector.invalid' | translate"
    (closed)="toast = false"
/>
